import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.LOGS_CONTROL}/v1/Log`;

async function fetchOperationTypes() {

  const url = `${basePath}/operationTypes?PageNumber=1&PageSize=9999`
  try {
    let response = await api.get(url);
    
    let treated = errorHandling.handleResponse(response, "logControlService.fetchOperationTypes");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "logControlService.fetchOperationTypes");
    return null;
  }
};

async function search(payload) {

  const url = `${basePath}/operationType`
  try {
    let response = await api.post(url, payload);
    
    let treated = errorHandling.handleResponse(response, "logControlService.search");
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "logControlService.search");
    return null;
  }
}


export const logControlService = {
  fetchOperationTypes,
  search
};
